<div class="space-y-5">
  <!-- Context Banner -->
  <div class="p-3.5 rounded-xl bg-surface border border-border flex items-start gap-3">
    <div class="p-2 rounded-lg bg-primary-low-contrast text-primary shrink-0">
      <lucide-icon name="Sparkles" class="w-4 h-4"></lucide-icon>
    </div>
    <div class="flex-1 min-w-0">
      <app-text size="sm" weight="semibold" class="text-foreground block">
        AI Payout Schedule &amp; Remittance Parser
      </app-text>
      <app-text size="xs" variant="muted" class="mt-0.5 block">
        Upload one or more Factoring Schedules (WEX, Kingpin, RTS, Triumph, etc.) or Direct Bill Remittance PDFs. Loads are matched automatically by Load ID across all invoices for your fleet, and you will verify the results before any payment is applied.
      </app-text>
      @if (hintInvoiceNumber) {
        <div class="mt-2">
          <app-badge
            [title]="'Linked to Invoice ' + hintInvoiceNumber"
            variant="info"
            badgeStyle="soft"
            size="xs"
          ></app-badge>
        </div>
      }
    </div>
  </div>

  <!-- Dropzone -->
  <div
    class="border-2 border-dashed rounded-xl p-6 text-center transition-colors cursor-pointer"
    [class.border-primary]="isDragging()"
    [class.bg-primary-low-contrast]="isDragging()"
    [class.border-border]="!isDragging()"
    [class.bg-surface]="!isDragging()"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
    (drop)="onDrop($event)"
    (click)="fileInput.click()"
  >
    <input
      #fileInput
      type="file"
      accept="application/pdf,.pdf"
      multiple
      class="hidden"
      (change)="onFileInputChange($event)"
    />
    <div class="w-12 h-12 rounded-full bg-surface-high border border-border mx-auto flex items-center justify-center text-primary mb-3">
      <lucide-icon name="UploadCloud" class="w-6 h-6"></lucide-icon>
    </div>
    <app-text size="sm" weight="semibold" class="text-foreground block">
      Drop Payout Schedule PDF(s) here or click to browse
    </app-text>
    <app-text size="xs" variant="muted" class="mt-1 block">
      Supports single or multiple PDF files &bull; Non-blocking background extraction
    </app-text>
  </div>

  <!-- Selected Files List -->
  @if (selectedFiles().length > 0) {
    <div class="space-y-2">
      <div class="flex items-center justify-between">
        <app-text size="xs" weight="semibold" variant="muted" class="uppercase tracking-wider">
          Selected Schedules ({{ selectedFiles().length }})
        </app-text>
      </div>
      <div class="divide-y divide-border rounded-xl border border-border bg-surface max-h-52 overflow-y-auto">
        @for (file of selectedFiles(); track file.name + file.size; let i = $index) {
          <div class="px-3.5 py-2.5 flex items-center justify-between gap-3">
            <div class="flex items-center gap-2.5 min-w-0">
              <div class="w-8 h-8 rounded-lg bg-surface-high border border-border flex items-center justify-center text-primary shrink-0">
                <lucide-icon name="FileSpreadsheet" class="w-4 h-4"></lucide-icon>
              </div>
              <div class="min-w-0">
                <app-text size="sm" weight="medium" class="text-foreground truncate block">
                  {{ file.name }}
                </app-text>
                <app-text size="xs" variant="muted" class="block">
                  {{ formatFileSize(file.size) }}
                </app-text>
              </div>
            </div>
            <app-button
              variant="ghost"
              size="xs"
              [iconOnly]="true"
              icon="Trash2"
              [disabled]="isUploading()"
              (click)="removeFile(i)"
            ></app-button>
          </div>
        }
      </div>
    </div>
  }

  <!-- Footer Actions -->
  <div class="flex items-center justify-end gap-2.5 pt-2 border-t border-border">
    <app-button
      variant="outline"
      size="sm"
      [disabled]="isUploading()"
      (click)="close()"
    >
      Cancel
    </app-button>
    <app-button
      variant="primary"
      size="sm"
      icon="Sparkles"
      [loading]="isUploading()"
      [disabled]="selectedFiles().length === 0 || isUploading()"
      (click)="startProcessing()"
    >
      Extract &amp; Verify ({{ selectedFiles().length }})
    </app-button>
  </div>
</div>
